import React from "react";
import RightHandSide from "../../Common/Services/RightHandSide";
import AboutInnBanContent from "../../Common/InnerBanner/AboutInnBanContent";
import { AboutInnerBanner } from "../../Common/InnerBanner/AboutInnerBanner";
import HeadContent from "../BlogContent/HeadContent";
import HeadDesign from "../BlogContent/HeadDesign";
import Info from "../BlogContent/Info";
import List from "../BlogContent/List";
import InfoContent from "../BlogContent/InfoContent";
import ListContent from "../BlogContent/ListContent";
import RecentBlogsList from "../BlogContent/RecentBlogsList";
import { Helmet } from "react-helmet";

const Blog45 = () => {
  const { image, heading, pageName } = AboutInnBanContent.BlogDetails;
  const { bg, para, date, blogHeading } = HeadContent.blog_45;

  const { title, p } = InfoContent.Blog_45.one;
  const { title2, p2 , p2a } = InfoContent.Blog_45.two;
  const { title3, p3 } = InfoContent.Blog_45.three;
  const { title4, p4 } = InfoContent.Blog_45.four;
  const { title5, p5 } = InfoContent.Blog_45.five;
//   const { Ctitle, Cp } = InfoContent.Blog_45.conclusion;

  const { liss2 } = ListContent.Blog_45.L2;
  const { liss3 } = ListContent.Blog_45.L3;
//   const { liss4 } = ListContent.Blog_45.L4;

  return (
    <>
      <Helmet>
        <title>PCOS and Fertility: Chances of Getting Pregnant with PCOS</title>

        <meta
          name="description"
          content="Learn how PCOS affects fertility and your chances of getting pregnant. Discover lifestyle tips, treatments, and options to improve conception with PCOS."
        />

        <meta
          name="keywords"
          content="PCOS and fertility, chances of getting pregnant with PCOS, fertility with PCOS, PCOS chances of conceiving, how PCOS affects fertility, improve chances of getting pregnant with PCOS, PCOS infertility treatment, ovulation and PCOS"
        />

        <link
          rel="canonical"
          href="https://www.acmefertility.com/45/Azoospermia-Explained"
        />

        {/* Article Schema */}

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalCondition",
            name: "Azoospermia",
            alternateName: "Zero sperm count",
            description:
              "Azoospermia is a medical condition where a man has a total absence of sperm in his ejaculate, categorized into obstructive and non-obstructive types.",
            associatedAnatomy: {
              "@type": "AnatomicalStructure",
              name: "Male Reproductive System",
            },
            possibleTreatment: [
              {
                "@type": "MedicalTherapy",
                name: "Micro-TESE",
              },
              {
                "@type": "MedicalTherapy",
                name: "Surgical Sperm Retrieval",
              },
            ],
            author: {
              "@type": "Organization",
              name: "Acme Fertility",
            },
            url: "https://www.acmefertility.com/azoospermia-meaning-causes-treatment",
          })}
        </script>

        {/* Author Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "@id": "https://www.acmefertility.com/#author",
            name: "Acme Fertility",
            url: "https://www.acmefertility.com/",
          })}
        </script>

        {/* FAQ Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is azoospermia?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Azoospermia is a medical condition where a man has a total absence of sperm in his ejaculate.",
                },
              },
              {
                "@type": "Question",
                name: "What are the types of azoospermia?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Azoospermia is categorized into two main types: obstructive azoospermia and non-obstructive azoospermia.",
                },
              },
              {
                "@type": "Question",
                name: "Can azoospermia be treated?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Treatment depends on the underlying cause and may include procedures such as Micro-TESE and surgical sperm retrieval.",
                },
              },
              {
                "@type": "Question",
                name: "What is Micro-TESE?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Micro-TESE is a specialized microsurgical procedure used to search for tiny areas of sperm production in men with non-obstructive azoospermia.",
                },
              },
            ],
          })}
        </script>
        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "@id":
              "https://www.acmefertility.com/azoospermia-meaning-causes-treatment#breadcrumb",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.acmefertility.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Fertility",
                item: "https://www.acmefertility.com/Fertility.php",
              },
              {
                "@type": "ListItem",
                position: 3,
                name: "Azoospermia Meaning: Types, Causes & Treatment Options",
                item: "https://www.acmefertility.com/azoospermia-meaning-causes-treatment",
              },
            ],
          })}
        </script>
      </Helmet>

      <AboutInnerBanner image={image} heading={heading} pageName={pageName} />

      <div className="blog-area pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <HeadDesign
                bg={bg}
                para={para}
                date={date}
                blogHeading={blogHeading}
              />

              <Info title={title} p={p} />
               <Info title={title2} p={p2} />
                 <List liss={liss2} />
                 <Info p={p2a} />
              <Info title={title3} p={p3} />
              <List liss={liss3} />
              <Info title={title4} p={p4} />
              <Info title={title5} p={p5} />
              

              {/* 
              <Info title={title} p={p} />
              <Info title={title2} p={p2} />
              <List liss={liss2} />
              <Info title={title3} p={p3} />
              <List liss={liss3} />
              <Info title={title4} p={p4} />
              <List liss={liss4} />
              <Info title={Ctitle} p={Cp} />
               */}

            </div>

            <div className="col-lg-4">
              <RecentBlogsList />
              <RightHandSide />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog45;
